// PreventiApp · Layout para pantallas de autenticación
import React from 'react';
import PreventiAppLogo from '../components/PreventiAppLogo';

export const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="min-h-screen flex items-center justify-center bg-[#F4F7FE] px-4 py-10">
    <div className="w-full max-w-md">
      <div className="flex justify-center mb-6">
        <PreventiAppLogo />
      </div>
      <div className="bg-white rounded-2xl shadow-[0_10px_40px_-10px_rgba(11,27,94,0.15)] p-8">
        <h1 className="text-2xl font-extrabold text-[#0B1B5E] tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#475472] mt-1.5">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
      {footer && <div className="mt-4 text-center text-sm text-[#475472]">{footer}</div>}
    </div>
  </div>
);

export default AuthLayout;
